<template>
  <div>
    <Header>
      <template slot="right">
        <!--
        <div class="m-r-20 link link-blue"
             v-if="$user && !$user.wechat_info && clientWidth >= 550"
             @click="teacherDialog.visible = true">
          绑定微信，使用智能批改助手移动端
        </div>
        -->
        <el-dropdown slot="right" trigger="click">
          <div class="c-p">
            <icon name="user" class="user-icon v-a-middle m-r-5"/>
            <span class="v-a-middle">{{$user && $user.name}}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="$goLogin()">
              <icon name="power-off" class="v-a-middle m-r-5"/>
              <span class="v-a-middle">登出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </Header>
    <TeacherDialog :visible.sync="teacherDialog.visible"/>
  </div>
</template>
<script>
import Header from './Header'
import TeacherDialog from '../base/TeacherDialog.vue'

export default {
  components: {
    Header,
    TeacherDialog
  },
  data () {
    return {
      clientWidth: document.body.clientWidth,
      teacherDialog: { visible: false }
    }
  },
}
</script>
<style lang="scss" scoped>
.user-icon {
  color: #ced8e6;
}

.el-dropdown-menu {
  padding: 2px 0;
}
</style>
